interface StatusBarProps {
  file: File | null;
}

function StatusBar({ file }: StatusBarProps) {
  if (file) {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-green-50 px-4 py-3 text-sm text-green-700">
        📄 <span className="font-medium">{file.name}</span> ready to process.
      </div>
    );
  }

  return (
    <div className="rounded-lg bg-blue-50 px-4 py-3 text-sm text-blue-700">
      📁 Upload a file above to get started.
    </div>
  );
}

export default StatusBar;
